export const categories = [
  {
    id: 'recommended',
    name: '热门推荐',
    slug: 'recommended',
    icon: 'ri-fire-line',
    description: '精选全网最热视频内容，每日更新热门影视剧集，西瓜视频为您推荐最受欢迎的在线播放资源',
    color: 'primary',
  },
  {
    id: 'movies',
    name: '最新电影',
    slug: 'movies',
    icon: 'ri-film-line',
    description: '海量最新电影高清在线观看，蜜桃视频频道提供国内外热门大片，无需下载即点即看',
    color: 'accent',
  },
  {
    id: 'series',
    name: '热门剧集',
    slug: 'series',
    icon: 'ri-tv-2-line',
    description: '最新电视剧、网剧高清全集在线播放，红桃视频频道每日同步更新热门剧集资源',
    color: 'primary',
  },
  {
    id: 'variety',
    name: '综艺娱乐',
    slug: 'variety',
    icon: 'ri-emotion-happy-line',
    description: '热门综艺节目高清在线观看，樱桃视频频道汇集各类真人秀、脱口秀、音乐节目',
    color: 'accent',
  },
  {
    id: 'anime',
    name: '动漫动画',
    slug: 'anime',
    icon: 'ri-rocket-line',
    description: '最新动漫番剧高清在线播放，西瓜视频动漫频道实时更新国产与海外热门动画作品',
    color: 'primary',
  },
  {
    id: 'documentary',
    name: '纪录片',
    slug: 'documentary',
    icon: 'ri-earth-line',
    description: '高质量纪录片免费在线观看，涵盖自然、历史、科技、人文等丰富题材内容',
    color: 'accent',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};